import React, { Component } from "react";
//import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import TabbedCards from "./Tasks";
import TaskRepository from "./mentorrepository";
import Footer from "./Footer";
import "./Home.css";

import { withRouter } from 'react-router-dom';

class Home extends Component {
  render() {
    const { location } = this.props;
    const routeName = location.pathname.replace("/", "");

    return (
      <div className="homeContainer">
        {routeName === "mentoring" && <TabbedCards />}
        {routeName === "repository" && <TaskRepository />}
        <Footer />
      </div>
    );
  }
}

export default Home;
